<template>
  <div>
    <vca-row>
      <vca-card class="shadowed">
        <General />
      </vca-card>

      <vca-card class="shadowed">
        <Crew />
        <Newsletter />
      </vca-card>
    </vca-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Newsletter from "@/components/account/settings/Newsletter";
import General from "@/components/account/profile/General";
import Crew from "@/components/account/profile/Crew";
export default {
  name: "AccountProfile",
  components: { Newsletter, General, Crew },
  methods: {
    update() {
      this.$store.dispatch({ type: "user/address/update" });
    },
  },
  computed: {
    ...mapGetters({
      user: "user/current",
    }),
  },
  created() {
    this.$store.dispatch("refresh");
  },
};
</script>
